import React from 'react';
import Variety from '../../../assets/Service-icon/Global Hotel.svg';
import BrandStrategy from '../../../assets/Service-icon/BrandStrategy.svg';
import SpecialDeals from '../../../assets/Service-icon/special deals.svg';

const HotelOptions = () => {
  const options = [
    {
      id: 1,
      img: Variety,
      title: 'Explore a Variety of Hotels',
      text: 'Discover a curated selection of hotels that cater to every taste and budget. From boutique hotels with unique charm to renowned international chains, BlueLagoon Travels brings you a world of options for your consideration.',
    },
    {
      id: 2,
      img: BrandStrategy,
      title: 'Brand Strategy',
      text: 'Have questions or need assistance? Our dedicated customer support team is available 24/7 to address any queries or concerns, ensuring a smooth and stress-free booking experience.',
    },
    {
      id: 3,
      img: SpecialDeals,
      title: 'Special Deals and Packages',
      text: 'Stay updated on exclusive deals and packages that can enhance your stay. Our platform is dedicated to providing you with the best value for your money, ensuring that you enjoy both comfort and savings.',
    },
  ];

  return (
    <div className='px-4 py-10 text-center'>
      {/* Section Heading */}
      <h2 className='mb-12 text-3xl font-bold text-gray-700 md:text-4xl'>
        A World of Choices: Diverse Hotel Options
      </h2>

      {/* Grid */}
      <div className='mx-auto grid max-w-6xl gap-8 md:grid-cols-3'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg p-6'
          >
            <img
              src={item.img}
              alt={item.title}
              className='mb-4 h-24 w-24 object-contain'
            />
            <h3 className='text-dark mb-4 text-xl font-semibold md:text-2xl'>{item.title}</h3>
            <p className='text-justify leading-relaxed text-gray-700'>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotelOptions;
